// test2143
(2143 && 0);
